import React, { Component } from 'react';
import Modal from './Modal';
import ButtonCustom from './ButtonCustom';
import { Grid } from '@material-ui/core';
import { withStyles, } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Typo from './CustomTypo'

const styles = theme => ({
    marginTop: {
        marginTop: theme.spacing(6),
    },
    form: { minWidth: 290 },
    icon: {
        width: '80px',
        height: '80px'
    },
    message: {
        textAlign: 'center',
        marginTop: theme.spacing(6),
        width: '100%'
    }
});

class ModalAlert extends Component {
    
    onClose(){
        const { onClose, error } = this.props;
        onClose();
    }

    render() {
        const { classes, t, children, maxWidth } = this.props;
        return (
            <Modal
                maxWidth={maxWidth ? maxWidth : 'xs'}
                open={this.props.open}
                onClose={this.onClose}
                hideHeader={true}
                content={
                    <Grid xs={12} container item direction='row' justify="center" >
                        <Grid xs={12} container item direction='row' justify="center" >
                            {this.props.isCustomMessage ? this.props.message :
                                <Typo variant='body2' className={classes.message}>{t(this.props.message)}</Typo>
                            }
                        </Grid>
                        {children}
                    </Grid>
                }
                action={
                    <Grid xs={10} container item direction='row' justify="center" >
                        {!this.props.hideButtonClose && <ButtonCustom color='primary' fullWidth
                            onClick={() => this.onClose()}
                        >{this.props.buttonLabel ? this.props.buttonLabel : (t('Close'))} </ButtonCustom>}
                    </Grid>
                }
            >
            </Modal>
        );
    }


}

export default withTranslation()(withStyles(styles)(ModalAlert));